import { StyleProps, Text, useToast } from "@chakra-ui/react";
import { useEffect, useState } from "react";

import { $ok } from "foundation-ts/commons";
import { Nullable, UUID } from "foundation-ts/types";
import { ConsumptionsStructure } from "@bcasmart/doxecure-commons/doxecureTypes";

import { ColumnTitle } from "@components/ColumnTitle/ColumnTitle";
import { ConsumptionsBox } from "@components/ConsumptionsBox/ConsumptionsBox";
import { PageShellWithThreeColumns } from "@components/PageShellWithThreeColumns/PageShellWithThreeColumns";
import { useAuthContext } from "@hooks/useAuthContext";
import { exportCorporationConsumptions, getCorporationConsumptions, getCorporationCurrentConsumption } from "@services/corporations.service";
import { exportConsumptions, getConsumptions, getCurrentConsumption } from "@services/stats.service";
import { $g1Color } from "@/theme/G1Style";
import { defaultErrorToast } from "@utils/toast";

export const ConsumptionsView = ({ maxWidth }: StyleProps) => {
    const { connectedUser } = useAuthContext();
    const [nbQualified, setNbQualified] = useState<number>(0) ;
    const [nbAdvanced, setNbAdvanced] = useState<number>(0) ;
    const [consumptions, setConsumptions] = useState<ConsumptionsStructure|null>(null) ;
    const [corporationName, setCorporationName] = useState<Nullable<string>>(null) ;
    const [corporationId, setCorporationId] = useState<Nullable<UUID>>(null) ;
    const toast = useToast() ;

    useEffect(() => {
        const currentConsumption = async (corporateId: Nullable<UUID>) => {
            const consumptions = $ok(corporateId) ? await getCorporationCurrentConsumption(corporateId!) : await getCurrentConsumption() ;
            setNbQualified($ok(consumptions) ? consumptions!.qualified : -1) ;
            setNbAdvanced($ok(consumptions) ? consumptions!.advanced : -1) ;
        }

        const consumptions = async (corporateId: Nullable<UUID>) => {
            const data = $ok(corporateId) ? await getCorporationConsumptions(corporateId!) : await getConsumptions() ;
            setConsumptions($ok(data) ? data! : null) ;
        }

        if ($ok(connectedUser)) {
            const corporation = connectedUser!.corporations?.first() ;
            currentConsumption(corporation?.apid) ;
            consumptions(corporation?.apid) ;
            setCorporationId(corporation?.apid) ;
            setCorporationName(corporation?.name) ;
        }
    }, [connectedUser]) ;

    const onExportConsumptions = async () => {
        try {
            if ($ok(corporationId)) {
                exportCorporationConsumptions(corporationId!, corporationName!) ;
            } else {
                exportConsumptions() ;
            }
        } catch (error) {
            toast(defaultErrorToast("Problème rencontré lors de l'export des données")) ;
        }
    }

    return (
        <PageShellWithThreeColumns
          centralContent={
              <>
              <ColumnTitle color={$g1Color('global.write')}>
                  <Text>Consommations</Text>
              </ColumnTitle>
              <ConsumptionsBox maxWidth={maxWidth} nbAdvanced={nbAdvanced} nbQualified={nbQualified} consumptions={consumptions} onExport={onExportConsumptions} />
              </>
          }
        />
    );
} ;